<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChooseToolPlacementHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="height-100 display-flex flex-wrap">
			<div class="flex-col-12">
				<div class="top-section">
					<h2 class="reg">Where do you want your tool to be triggered from?</h2>
					<h3 class="reg">Hover over placements to see details</h3>
				</div>
				<ToolPlacementSelector v-model="_selectedToolPlacementId" @click="onClick" />
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import props from './ChooseToolPlacement.props';
import ChooseToolPlacementHeader from './ChooseToolPlacementHeader.vue';
import ToolPlacementSelector from './ToolPlacementSelector.vue';
export default {
	name: 'ChooseToolPlacement',
	mixins: [WizardStepMixin],
	props,
	components: { ChooseToolPlacementHeader, ToolPlacementSelector },
	computed: {
		_selectedToolPlacementId: {
			get() {
				return this.selectedToolPlacementId;
			},
			set(value) {
				this.updateState({ key: 'selectedToolPlacementId', value });
			},
		},
	},
	methods: {
		onClick() {
			this.$nextTick(() => {
				this.nextStep();
			});
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/components/CreationWizard/assets/top-section.scss';
</style>
